export default __webpack_public_path__ + "static/media/icon-Hub-Review.98203029.svg";